// removed by extract-text-webpack-plugin
module.exports = {"hikeColor":"#58924D","runColor":"#0076C0","fitnessColor":"#375A92","rideColor":"#C53426","walkColor":"#885291","baseLineHeight":"24px","white":"rgb(255, 255, 255)","offWhite":"rgba(255, 255, 255, 0.2)","spinDuration":"1s","pulseDuration":"750ms","loaderGray":"#e5e5e5","spin":"spin-3wUjD","comet":"comet-pBdLe","pulse":"pulse-1R7H1","pulseanim":"pulseanim-2zG-A","cometspin":"cometspin-1OW9e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/Loader/_singleElement.css
// module id = 1276
// module chunks = 1